export default {"src":"/_next/static/media/why-one-legacy-icon.cfad868e.svg","height":66,"width":68,"blurWidth":0,"blurHeight":0};